define('home/views/ChannelGroupCardView',[
    'backbone-marionette',

    'home/templates/channelGroupCard',
], function (
    Marionette,

    channelGroupCardTemplate
) {
    'use strict';

    /**
     * A card showing a channel group name and logo.
     *
     * Expects a channel model
     */
    var ChannelGroupCardView = Marionette.ItemView.extend({
        template: channelGroupCardTemplate,

        templateHelpers: function () {
            var bannerColor = this.model.get('bannerColor');

            return {
                bannerColor: bannerColor ? '-' + bannerColor : '',
                exploreTab: this.exploreTab,
            };
        },

        initialize: function (options) {
            this.exploreTab = options && options.exploreTab;
        },
    });

    return ChannelGroupCardView;
});

